// @flow
import dp4_4l1q1 from './l1q1';
import dp4_4l1q2 from './l1q2';
import dp4_4l1q3 from './l1q3';
import dp4_4l1q4 from './l1q4';
import dp4_4l3q1 from './l3q1';
import dp4_4l3q2 from './l3q2';
import dp4_4l3q3 from './l3q3';
import dp4_4l3q4 from './l3q4';
import dp4_4l5q1 from './l5q1';
import dp4_4l5q2 from './l5q2';
import dp4_4l5q3 from './l5q3';
import dp4_4l7q1 from './l7q1';
import dp4_4l7q2 from './l7q2';
import dp4_4l7q3 from './l7q3';

const questions = {
    dp4_4l1q1,
    dp4_4l1q2,
    dp4_4l1q3,
    dp4_4l1q4,
    dp4_4l3q1,
    dp4_4l3q2,
    dp4_4l3q3,
    dp4_4l3q4,
    dp4_4l5q1,
    dp4_4l5q2,
    dp4_4l5q3,
    dp4_4l7q1,
    dp4_4l7q2,
    dp4_4l7q3
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat4.4/index.js